import { useEffect, useState } from "react";

const hasDarkClass = (el: HTMLElement) =>
  el.classList.contains("dark") || el.classList.contains("darkest");

/**
 * Whether the app is currently in a dark theme. Reads the theme class off
 * <html> — both "dark" and "darkest" count as dark — and keeps in sync via a
 * MutationObserver. Provider-independent on purpose, so it's safe to use in
 * low-level UI primitives and portals (e.g. tooltips) without coupling them to
 * SettingsProvider.
 */
export function useIsDark() {
  const [isDark, setIsDark] = useState(
    () =>
      typeof document !== "undefined" &&
      hasDarkClass(document.documentElement),
  );

  useEffect(() => {
    const el = document.documentElement;
    const update = () => setIsDark(hasDarkClass(el));
    update();
    const observer = new MutationObserver(update);
    observer.observe(el, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  return isDark;
}
